export enum TransactionStatus {
    // A transaction that was created on a kiosk, but has not yet synchronized to a client application.
    Kiosk = 0,

    // A transaction that was synchronized from a kiosk or created directly on a client application.
    Client = 1,

    // A transaction that was synchronized to a server, but its processing status is as yet unknown.
    Server = 2,

    // A transaction that was processed successfully.
    Processed = 3,

    // A transaction that was processed and rejected.
    Rejected = 4,

    // A transaction that could not be processed, due to incomplete data or an error with the transaction processor.
    Faulted = 5,

    // A previously-processed transaction that was refunded successfully.
    Refunded = 6,

    // A previously-processed transaction for which a refund attempt failed.
    RefundFailed = 7,

    // A transaction that was administratively removed (and thus should be deleted from mobile and kiosk applications).
    Removed = 8,

    // A transaction that is in a pending state.
    Pending = 9,

    // A transaction that is in was partially refunded.
    PartiallyRefunded = 10,

    // A transaction in which a error occurred on the server during processing.
    ServerError = 11,

    // A transaction that was collected offline (e.g. cash or check) and should not be resubmitted for online processing.
    Offline = 12,

    Unknown = 99
}